//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { getMedsMaxWidthUrl } from '@utils/meds';

export const getContentItemImageUrl = (
  contentItem: IContentLibraryItem,
  width: number,
) => {
  return contentItem.fileId
    ? getMedsMaxWidthUrl(contentItem.fileId, width)
    : contentItem.imageUrl;
};
